module.exports = __webpack_public_path__ + "static/media/logo.e5778f30.png";